import React from 'react';
var Group = function (props) {
    var classes = props.classes, title = props.title, subTitle = props.subTitle, image = props.image;
    return (React.createElement("div", { className: classes.group },
        React.createElement("img", { src: "" + image }),
        React.createElement("p", { className: classes.gropTitle }, title),
        React.createElement("p", { className: classes.groupSubTitle }, subTitle)));
};
export default Group;



//////////////////
// WEBPACK FOOTER
// ./src/components/Group/Group.tsx
// module id = 1352
// module chunks = 0